
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("eRtVx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "Navigation", () => $83e6e0cff8bb8953$export$b8a61e5c71402559);
$parcel$export(module.exports, "default", () => $83e6e0cff8bb8953$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $eMKuN = parcelRequire("eMKuN");
const $83e6e0cff8bb8953$export$b8a61e5c71402559 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eMKuN.NavigationJourney), null));
var $83e6e0cff8bb8953$export$2e2bcd8739ae039 = $83e6e0cff8bb8953$export$b8a61e5c71402559;

});
parcelRegister("eMKuN", function(module, exports) {
$parcel$export(module.exports, "NavigationJourney", () => $079aca5aa9a26448$export$1e48a6a7996903f1);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $kRgKj = parcelRequire("kRgKj");
var $iFaP4 = parcelRequire("iFaP4");

var $gCY1z = parcelRequire("gCY1z");

var $dmrGb = parcelRequire("dmrGb");
const $079aca5aa9a26448$var$getInitialStateFromSession = (host)=>{
    const isNew = (0, $dmrGb.isNewJourney)(host);
    const { prevUrl: prevUrl, attributes: attributes } = (0, $dmrGb.restoreFromSession)(isNew) || {};
    return {
        prevUrl: prevUrl,
        attributes: {
            steps: 0,
            prevPage: null,
            isPrevPageSpa: null,
            currentPage: null,
            isCurrentPageSpa: null,
            ...attributes,
            isInitial: true,
            isNew: isNew
        }
    };
};
const $079aca5aa9a26448$var$debouncedChange = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(({ navJourneyState: navJourneyState, location: location, route: route, createAnalyticsEvent: createAnalyticsEvent, setNavJourneyState: setNavJourneyState })=>{
    const { prevUrl: prevUrl, attributes: attributes } = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    navJourneyState || $079aca5aa9a26448$var$getInitialStateFromSession(window.location.host);
    const currentUrl = (0, $dmrGb.cleanUrl)(location.pathname, location.search);
    const currentPage = route?.name;
    if (route?.isRedirect === true) return;
    if (currentUrl === null || currentPage == null || prevUrl === currentUrl // refresh page
    ) return;
    const newAttributes = {
        ...attributes,
        prevPage: attributes?.currentPage,
        isPrevPageSpa: attributes?.isCurrentPageSpa,
        currentPage: currentPage,
        isCurrentPageSpa: __SPA__
    };
    const analyticsEvent = createAnalyticsEvent({});
    (0, $kRgKj.fireOperationalAnalytics)(analyticsEvent, 'NavigationJourney navigated', newAttributes);
    newAttributes.steps += 1;
    newAttributes.isInitial = false;
    newAttributes.isNew = false;
    const newState = {
        prevUrl: currentUrl,
        attributes: newAttributes
    };
    setNavJourneyState(newState);
    (0, $dmrGb.saveToSession)(newState);
}, 1000);
const $079aca5aa9a26448$export$1e48a6a7996903f1 = ()=>{
    const [navJourneyState, setNavJourneyState] = (0, $eJOHy.useState)(null);
    const [{ location: location, route: route }] = (0, $gCY1z.useRouter)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iFaP4.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>$079aca5aa9a26448$var$debouncedChange({
            navJourneyState: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'State | null'.
            navJourneyState,
            location: location,
            route: route,
            createAnalyticsEvent: createAnalyticsEvent,
            setNavJourneyState: setNavJourneyState
        }), [
        location,
        navJourneyState,
        route,
        createAnalyticsEvent,
        setNavJourneyState
    ]);
    return null;
};

});
parcelRegister("dmrGb", function(module, exports) {
$parcel$export(module.exports, "isNewJourney", () => $7d6bdc0928369b17$export$cba1f44b1e2c915c);
$parcel$export(module.exports, "restoreFromSession", () => $7d6bdc0928369b17$export$e59f5ef7117129a1);
$parcel$export(module.exports, "saveToSession", () => $7d6bdc0928369b17$export$15a2109d39af6362);
$parcel$export(module.exports, "cleanUrl", () => $7d6bdc0928369b17$export$39cd5310d932e557);

var $LFmXM = parcelRequire("LFmXM");

var $b5RwB = parcelRequire("b5RwB");

var $8tIrO = parcelRequire("8tIrO");

var $4cTDP = parcelRequire("4cTDP");
const $7d6bdc0928369b17$var$SESSION_KEY = 'navigation-journey';
const $7d6bdc0928369b17$var$RELEVANT_PARAMS = [
    'filter',
    'selectedItem',
    'rapidView',
    'view',
    'selectPageId',
    'chart'
];
const $7d6bdc0928369b17$var$storage = (0, $LFmXM.default)(()=>(0, $8tIrO.createSessionStorageProvider)('page-container'));
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $7d6bdc0928369b17$var$getReferrer = ()=>document ? document.referrer : '';
const $7d6bdc0928369b17$export$cba1f44b1e2c915c = (host)=>{
    const isComingFromSameHost = $7d6bdc0928369b17$var$getReferrer().includes(host);
    // three situation where isComingFromSameHost will be false:
    // 1. the url change is from spa transition, document.referrer = '',
    // But in this case, we get the state from navJourneyState, this code will not run
    // 2. we navigate from a different host
    // 3. we enter the url directly or open the tab via bookmark, document.referrer = ''
    return !isComingFromSameHost;
};
const $7d6bdc0928369b17$export$e59f5ef7117129a1 = (isNew)=>{
    let journey = null;
    // protect from tab reuse
    if (isNew) return journey;
    try {
        journey = JSON.parse($7d6bdc0928369b17$var$storage().get($7d6bdc0928369b17$var$SESSION_KEY));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
    /* ignore */ }
    return journey;
};
const $7d6bdc0928369b17$export$15a2109d39af6362 = (value)=>{
    try {
        $7d6bdc0928369b17$var$storage().set($7d6bdc0928369b17$var$SESSION_KEY, JSON.stringify(value));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
    /* ignore */ }
};
const $7d6bdc0928369b17$export$39cd5310d932e557 = (pathname, params)=>{
    let url = pathname.replace(/\/$/, '');
    // ignore /browse redirects or sw classic redirects
    if (/\/browse\/\w+$/.test(pathname) || params.includes('useStoredSettings')) return null;
    // ignore PIN + issue key urls (we only care about filter)
    // issue key is no longer a path param for PIN. This logic can be removed on FG cleanup
    if (!(0, $4cTDP.fg)('jira_list_nin_merge') && /\/projects\/\w+\/issues\/\w+-\d+/.test(pathname)) url = pathname.replace(/issues\/\w+-\d+(.*)$/, 'issues');
    url += '?';
    if (params) {
        const paramsObj = (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).parse(params);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const validParams = Object.keys(paramsObj).reduce((acc, pk)=>{
            if ($7d6bdc0928369b17$var$RELEVANT_PARAMS.includes(pk)) acc[pk] = paramsObj[pk];
            return acc;
        }, {});
        // ignore GIN issue key change (we only care about filter/jql)
        if (paramsObj.filter || paramsObj.jql) url = url.replace(/^\/issues\?$|^\/browse\/\w+-\d+(.*)$/, '/browse/ISSUE-1?');
        url += (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify(validParams);
    }
    return url;
};

});




//# sourceMappingURL=async-global-navigation-components.af0675b3.js.map
